import { createRouter, createWebHistory } from 'vue-router';
import Login from '../views/Login.vue';
import TodasPartidas from '../views/Games.vue';
import AoVivo from '../views/Live.vue';
import MinhasApostas from '../views/MyBets.vue';
import Conta from '../views/AccountDashboard.vue';
import Register from '../views/Register.vue';
import Blocked from '../views/Blocked.vue';

// Função simulada para verificar se o usuário está logado
function isLoggedIn() {
  // Substitua essa lógica pela verificação real do estado de login do seu usuário
  return localStorage.getItem('userLoggedIn') === 'true';
}

// Função para verificar se o IP do usuário está bloqueado
function isBlockedCookie() {
  return document.cookie.split(';').some(function(cookie) {
    return cookie.trim().startsWith('dale_blocked=1');
  });
}
function isIpBlocked() {
  return localStorage.getItem('ipBlocked') === 'true' || isBlockedCookie();
}

// Função para limpar todos os tokens de autorização
function clearAllAuthTokens() {
  localStorage.removeItem('userToken');
  localStorage.removeItem('userLoggedIn');
  localStorage.removeItem('username');
  localStorage.removeItem('botPermissions');
  
  // Limpar todos os cookies também
  document.cookie.split(';').forEach(cookie => {
    const [name] = cookie.trim().split('=');
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  });
}

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    {
      path: '/blocked',
      component: Blocked,
      meta: { allowWhenBlocked: true }
    },
    {
      path: '/login',
      component: Login
    },
    {
      path: '/register',
      component: Register
    },
    {
      path: '/partidas',
      component: TodasPartidas,
      meta: { requiresAuth: true }
    },
    {
      path: '/ao-vivo',
      component: AoVivo,
      meta: { requiresAuth: true }
    },
    {
      path: '/apostas',
      component: MinhasApostas,
      meta: { requiresAuth: true }
    },
    {
      path: '/conta',
      component: Conta,
      meta: { requiresAuth: true }
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: () => {
        // Funciona como uma função que decide para onde redirecionar
        return isLoggedIn() ? '/partidas' : '/login';
      }
    }
    // Adicione outras rotas aqui
  ],
});

// Interceptar todas as navegações antes que ocorram
router.beforeEach((to, from, next) => {
  // IMPORTANTE: Se já estiver indo para /blocked, permitir sempre sem verificações
  if (to.path === '/blocked') {
    console.log('Navegando para /blocked - permitindo sem verificações');
    next();
    return;
  }
  
  // Verificar o bloqueio para outras rotas
  if (isIpBlocked()) {
    console.warn('Tentativa de navegação bloqueada:', to.path);
    
    // Limpar tokens de autenticação
    clearAllAuthTokens();
    
    // Redirecionar para a página de bloqueio usando o router
    // NÃO usar window.location.href que causa loops
    next('/blocked');
    return;
  }
  
  // Verifica se a rota requer autenticação e o usuário não está logado
  if (to.meta.requiresAuth && !isLoggedIn()) {
    next({ path: '/login' }); // Redireciona para a página de Login
  } else if (!to.meta.requiresAuth && isLoggedIn() && to.path === '/login') {
    next({ path: '/partidas' }); // Se o usuário está logado e tenta acessar /login, redireciona para /partidas
  } else {
    next(); // Caso contrário, continua a navegação normalmente
  }
});


export default router;
